import NotificationTypes from './notification_types';

export type NotificationModuleProvider = () => Promise<unknown>;

const types: Record<string, Record<string, NotificationModuleProvider> | undefined> =
  NotificationTypes;

/**
 * The lazy loader of the component that renders a notification. `event` is a
 * `<type>.<action>` key into NotificationTypes; an unknown or missing one gets the default.
 */
export const providerFor = (event: string | null | undefined): NotificationModuleProvider => {
  const [type, action] = (event ?? '').split('.');
  const provider = type && action ? types[type]?.[action] : undefined;

  return typeof provider === 'function' ? provider : NotificationTypes.default.new;
};
